import { render } from "./PasswordDetailsComponent.vue?vue&type=template&id=61169e8a&scoped=true&ts=true"
import script from "./PasswordDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./PasswordDetailsComponent.vue?vue&type=script&lang=ts"

import "./PasswordDetailsComponent.vue?vue&type=style&index=0&id=61169e8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61169e8a"]])

export default __exports__